export const productsData = [
  {
    id: 1,
    image: "03.jpg",
    name: "Men's Jacket",
    note: "Gray Denim Regular Men's Denim Jacket",
    description: "Lorate Solid men's Fashion Full Sleeves Latest Jacket for women With Button Closure Long Sleeve Casual Torn Lycra Women's Top..",
    discountPrice: "35.00",
    status: "none",
    price: 120.0,
    stock: "Out of stock",
    review: "(120 review)",
    category: "Men's Shirt",
    rating: 4,
    colors: ["White", "gray"],
    size: ["M", "L", "XL"],
    tags: ["Diesel", "Hudson", "Lee"],
    variants: [
      {
        color: "White",
        images: "01.jpg",
      },
      {
        color: "gray",
        images: "02.jpg",
      },
      {
        color: "black",
        images: "03.jpg",
      },
      {
        color: "pink",
        images: "04.jpg",
      },
    ],
  },
  {
    id: 2,
    image: "06.jpg",
    name: "Men's T-shirt",
    note: "Solid men's T-shirt",
    description: "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Women's Top.",
    discountPrice: "320.00",
    status: "Sale",
    ribbonClassName: "ribbon ribbon-danger",
    price: 260.0,
    stock: "In stock",
    review: "(120 review)",
    rating: 3,
    category: "Women's Top",
    colors: ["green", "gray"],
    size: ["M", "L", "XL"],
    tags: ["Levis", "Hudson", "Lee"],
    variants: [
      {
        color: "White",
        images: "05.jpg",
      },
      {
        color: "gray",
        images: "06.jpg",
      },
      {
        color: "gray",
        images: "07.jpg",
      },
      {
        color: "gray",
        images: "08.jpg",
      },
    ],
  },
  {
    id: 3,
    image: "09.jpg",
    name: "Women's Top",
    note: "Polyester Blend Women's Fit Dress",
    description: "Ravaiyaa - Attitude is everything Cotton Women's Dresses One Piece Button Dress.",
    discountPrice: "110.00",
    price: 60.0,
    status: "50%",
    stock: "In stock",
    review: "(200 review)",
    rating: 2,
    category: "Men's Jacket",
    colors: ["White", "gray", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Diesel", "Spykar", "Lee"],
    variants: [
      {
        color: "White",
        images: "09.jpg",
      },
      {
        color: "gray",
        images: "10.jpg",
      },
      {
        color: "gray",
        images: "11.jpg",
      },
      {
        color: "gray",
        images: "12.jpg",
      },
    ],
  },
  {
    id: 4,
    image: "07.jpg",
    name: "Women's T-shirt",
    note: "Regular Fit women's Casual Shirt",
    description: "Symbol women's Solid Regular Fit Full Sleeve Formal Shirt, Cotton Regular Fit women's Casual Shirt.",
    discountPrice: "610.00",
    price: 526.0,
    status: "none",

    stock: "In stock",
    review: "(410 review)",
    rating: 1,
    category: "Men's Shirt",
    colors: ["red", "gray", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Lee", "Levis", "Hudson"],
    variants: [
      {
        color: "White",
        images: "13.jpg",
      },
      {
        color: "gray",
        images: "14.jpg",
      },
      {
        color: "gray",
        images: "15.jpg",
      },
      {
        color: "gray",
        images: "16.jpg",
      },
    ],
  },
  {
    id: 5,
    image: "07.jpg",
    name: "Women's T-shirt",
    note: "Silk Cotton Regular Fit T-Shirt",
    description: "Rock Paper Scissors Womens Tank Top High Neck Cotton Top Stylish Women Top..",
    discountPrice: "230.00",
    price: 206.0,
    stock: "In stock",
    ribbonClassName: "ribbon ribbon-success ribbon-right",
    status: "50%",
    review: "(120 review)",
    rating: 5,
    category: "Women's Party Wear",
    colors: ["green", "White", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Diesel", "Spykar", "Denien"],
    variants: [
      {
        color: "White",
        images: "01.jpg",
      },
      {
        color: "gray",
        images: "02.jpg",
      },
    ],
  },
  {
    id: 6,
    image: "06.jpg",
    name: "Men's T-shirt",
    note: "Regular Fit Women's Casual Shirt",
    description: "Symbol women's Solid Regular Fit Full Sleeve Formal Shirt, Cotton Regular Fit women's Casual Shirt.",
    discountPrice: "560.00",
    price: 126.0,
    status: "Hot",
    ribbonClassName: "ribbon ribbon-warning",
    stock: "Out of stock",
    review: "(200 review)",
    rating: 4,
    category: "Jacket",
    colors: ["purple", "orange", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Lee", "Diesel", "Levis"],
    variants: [
      {
        color: "White",
        images: "03.jpg",
      },
      {
        color: "gray",
        images: "04.jpg",
      },
    ],
  },
  {
    id: 7,
    image: "13.jpg",
    name: "Men's Shirt",
    note: "Solid men's Dress",
    description: "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra men's Top.",
    discountPrice: "210.00",
    price: 105.0,
    status: "50%",
    ribbonClassName: "ribbon ribbon-warning",
    stock: "In stock",
    review: "(300 review)",
    rating: 3,
    category: "T-shirt",
    colors: ["orange", "pink", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Lee", "Diesel"],
    variants: [
      {
        color: "White",
        images: "05.jpg",
      },
      {
        color: "blue",
        images: "06.jpg",
      },
    ],
  },
  {
    id: 8,
    image: "13.jpg",
    name: "Men's Shirt",
    note: "Red Regular Men's Jacket",
    description: "Glamcci Women's Cotton Blend Printed TreckSuit Dress, Rayon Women's Regular Top.",
    discountPrice: "700.00",
    price: 500.0,
    status: "none",
    stock: "In stock",
    review: "(120 review)",
    rating: 5,
    category: "Men's Jacket",
    colors: ["purple", "pink", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Hudson", "Lee"],
    variants: [
      {
        color: "White",
        images: "07.jpg",
      },
      {
        color: "gray",
        images: "08.jpg",
      },
      {
        color: "gray",
        images: "09.jpg",
      },
      {
        color: "gray",
        images: "10.jpg",
      },
    ],
  },
  {
    id: 9,
    image: "15.jpg",
    name: "Woman Party Wear",
    note: "Gray Denim Regular Men's Denim Shirt",
    description: "Mylo Essentials Pre & Post Maternity/Nursing Maxi Dress with Both Sides Zipper for Easy Feeding – Garden Flowers.",
    discountPrice: "780.00",
    price: 626.0,
    status: "none",
    stock: "Out of stock",
    review: "(200 review)",
    rating: 5,
    category: "Men's Shirt",
    colors: ["White", "pink", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Spykar"],
    variants: [
      {
        color: "purple",
        images: "11.jpg",
      },
      {
        color: "pink",
        images: "12.jpg",
      },
      {
        color: "blue",
        images: "13.jpg",
      },
      {
        color: "White",
        images: "14.jpg",
      },
    ],
  },
  {
    id: 10,
    image: "04.jpg",
    name: "Women's Top",
    note: "Denim Regular Men's Women's Top",
    description: "Symbol Men's Solid Regular Fit Full Sleeve Formal Shirt, Cotton Regular Fit Men's Casual Shirt.",
    discountPrice: "680.00",
    price: 500.0,
    status: "none",
    stock: "Out of stock",
    review: "(410 review)",
    rating: 4,
    category: "Women's Top",
    colors: ["purple", "pink", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Hudson", "Lee"],
    variants: [
      {
        color: "White",
        images: "15.jpg",
      },
      {
        color: "gray",
        images: "16.jpg",
      },
      {
        color: "gray",
        images: "01.jpg",
      },
      {
        color: "gray",
        images: "02.jpg",
      },
    ],
  },
  {
    id: 11,
    image: "07.jpg",
    name: "Women's Top",
    note: "Cotton Blend Women's Skirt",
    description: "Women's Classic Stretchy All Time Trendy Pleated Skirt|Western Skirt |midi Skirt| plited Lehenga.",
    discountPrice: "480.00",
    price: 426.0,
    status: "none",
    stock: "In stock",
    review: "(120 review)",
    rating: 5,
    category: "Men's Jacket",
    colors: ["White", "pink", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Diesel", "Hudson", "Lee"],
    variants: [
      {
        color: "White",
        images: "03.jpg",
      },
      {
        color: "pink",
        images: "04.jpg",
      },
      {
        color: "blue",
        images: "05.jpg",
      },
      {
        color: "gray",
        images: "06.jpg",
      },
    ],
  },
  {
    id: 12,
    image: "05.jpg",
    name: "Women's T-shirt",
    note: "Regular Fit women's Casual Shirt",
    description: "Symbol Men's Solid Regular Fit Full Sleeve Formal Shirt, Cotton Regular Fit Men's Casual Shirt.",
    discountPrice: "820.00",
    price: 626.0,
    status: "none",
    stock: "In stock",
    review: "(200 review)",
    rating: 3,
    category: "Man's Shirt",
    colors: ["White", "pink", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Diesel", "Hudson", "Lee"],
    variants: [
      {
        color: "White",
        images: "07.jpg",
      },
      {
        color: "pink",
        images: "08.jpg",
      },
      {
        color: "blue",
        images: "09.jpg",
      },
      {
        color: "purple",
        images: "10.jpg",
      },
    ],
  },
  {
    id: 13,
    image: "14.jpg",
    name: "Women's Top",
    note: "Cotton Regular Fit T-Shirt",
    description: "Rock Paper Scissors Womens Tank Top High Neck Cotton Top Stylish Women Top.",
    discountPrice: "120.00",
    price: 50.0,
    status: "none",
    stock: "In stock",
    review: "(300 review)",
    rating: 3,
    category: "Women's Party Wear",
    colors: ["White", "pink", "blue"],
    size: ["M", "L", "XL"],
    tags: ["Diesel", "Hudson", "Lee"],
    variants: [
      {
        color: "White",
        images: "01.jpg",
      },
      {
        color: "pink",
        images: "12.jpg",
      },
      {
        color: "blue",
        images: "13.jpg",
      },
      {
        color: "black",
        images: "14.jpg",
      },
    ],
  },
  {
    id: 14,
    image: "08.jpg",
    name: "Men's T-shirt",
    note: "Cotton Regular Fit Men's jacket",
    description: "Lorate Solid Men's Fashion Full Sleeves Latest Jacket for Men With Button Closure Long Sleeve Casual Torn Lycra Women's Top..",
    discountPrice: "180.00",
    price: 145.0,
    status: "50%",
    ribbonClassName: "ribbon  ribbon-success",
    stock: "In stock",
    review: "(120 review)",
    rating: 2,
    category: "T-shirt",
    colors: ["White", "blue", "yellow"],
    size: ["M", "L", "XL"],
    tags: ["Diesel", "Lee"],
    variants: [
      {
        color: "White",
        images: "15.jpg",
      },
      {
        color: "blue",
        images: "16.jpg",
      },
      {
        color: "yellow",
        images: "01.jpg",
      },
      {
        color: "pink",
        images: "02.jpg",
      },
    ],
  },
  {
    id: 15,
    image: "01.jpg",
    name: "Women's T-shirt",
    note: "Regular Cotton Fit T-Shirt",
    description: "Rock Paper Scissors Womens Tank Top High Neck Cotton Top Stylish Women Top.",
    discountPrice: "260.00",
    price: 206.0,
    status: "Hot",
    ribbonClassName: "ribbon ribbon-right ribbon-warning",
    stock: "In stock",
    review: "(200 review)",
    rating: 1,
    category: "Men's Jacket",
    colors: ["black", "blue", "yellow"],
    size: ["M", "L", "XL"],
    tags: ["Lee"],
    variants: [
      {
        color: "black",
        images: "03.jpg",
      },
      {
        color: "blue",
        images: "04.jpg",
      },
      {
        color: "yellow",
        images: "05.jpg",
      },
      {
        color: "yellow",
        images: "06.jpg",
      },
    ],
  },
  {
    id: 16,
    image: "14.jpg",
    name: "Dream Beauty Fashion",
    note: "Denim Regular women's Jeans",
    description: "Mylo Essentials Pre & Post Maternity/Nursing Maxi jeans with Both Sides Zipper..",
    discountPrice: "920.00",
    price: 550.0,
    status: "none",
    stock: "Out of stock",
    review: "(300 review)",
    rating: 2,
    category: "Jacket",
    colors: ["black", "pink", "yellow"],
    size: ["M", "L", "XL"],
    tags: ["Hudson"],
    variants: [
      {
        color: "black",
        images: "07.jpg",
      },
      {
        color: "pink",
        images: "08.jpg",
      },
      {
        color: "yellow",
        images: "09.jpg",
      },
      {
        color: "blue",
        images: "10.jpg",
      },
    ],
  },
];

export const filterProductData = [
  {
    id: 2,
    colClass: "col-xl-6 col-sm-6",
    filterData: ["1", "2"],
  },
  {
    id: 3,
    colClass: "col-xl-4 col-sm-4",
    filterData: ["3", "4", "5"],
  },
  {
    id: 4,
    colClass: "col-xl-3 col-md-4 col-sm-5",
    filterData: ["6", "7", "8", "9"],
  },
  {
    id: 6,
    colClass: "col-xl-2 col-md-4 col-sm-5",
    filterData: ["10", "11", "12", "13", "14", "15"],
  },
];

export const productSlide1 = [
  {
    image: "01.jpg",
    title: "Woman T-shirt",
    text: "$100.00",
    rowClass: "mb-4",
  },
  {
    image: "02.jpg",
    title: "Dream Beauty Fashion",
    text: "$150.00",
  },
  {
    image: "03.jpg",
    title: "Womens's Dress",
    text: "$200.00",
  },
];

export const productSlide2 = [
  {
    image: "01.jpg",
    title: "Fancy Shirt",
    text: "$100.00",
    rowClass: "mb-4",
  },
  {
    image: "02.jpg",
    title: "Fancy Shirt",
    text: "$100.00",
    rowClass: "mb-4",
  },
  {
    image: "03.jpg",
    title: "Fancy Shirt",
    text: "$100.00",
  },
];

export const starData = (
  <span>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star font-warning me-1"></i>
    <i className="fa fa-star-half-o font-warning me-1"></i>
    <i className="fa fa-star-half-o font-warning"></i>
  </span>
);

export const productSizeArray: string[] = ["M", "L", "Xl"];

export const cartTableHeader = [
  "Product",
  "Product Name",
  "Price",
  "Quantity",
  "Action",
  "Total",
];
